import { TitleArrayPart } from './types'

export const getTitleArray = (title: string): TitleArrayPart[] => [
  [`Drag & Drop ${title}`, null],
  ['or', null],
  ['Select a file', { textDecoration: 'underline' }],
];
